import { render, staticRenderFns } from "./carousel-card.vue?vue&type=template&id=08b679aa&"
import script from "./carousel-card.vue?vue&type=script&lang=js&"
export * from "./carousel-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports